import { TYPES } from "@actions/buy-closet-items-actions";
import INITIAL_STATE from "./initial-state";

const buyClosetItemsReducer = (state = INITIAL_STATE.buyClosetItems, action) => {
  switch (action.type) {
    case TYPES.UPDATE_SELECTED_ITEMS_IDS: {
      const { itemsIds } = action;
      return {
        ...state,
        selectedItemsIds: itemsIds,
      };
    }

    case TYPES.SET_PENDING_CLOSET_SALES: {
      const { pendingClosetSales } = action;
      return {
        ...state,
        pendingClosetSales,
      };
    }

    case TYPES.RESET_BUY_ITEMS: {
      return INITIAL_STATE.buyClosetItems;
    }

    default:
      return state;
  }
};

export default buyClosetItemsReducer;
